import { request } from '@ux/util';
import testShoppers from '../enums/shopper-blocklist';
import PropTypes from 'prop-types';

// TODO: [UXP-9716] Rename file to reflect that Notifications no longer utilizes a cache mechanism

/**
 * Used to request notifications
 *
 * @param {string} href URl for get request from endpoint.href
 * @param {string} shopperId Customer identifier
 * @param {string} market Location and language date (e.g. en-US, el-GR, fr-CA)
 * @param {function} successCb Success callback
 * @param {function} errorCb Error callback used when error or response data is not an array
 *
 * @private
 */

// eslint-disable-next-line max-params
export function requestNotifications({ href, shopperId, market, successCb, errorCb }) {
  // Skip the real request for our test shoppers used for UI automation
  // to avoid overriding the mock request.
  if (testShoppers.indexOf(shopperId) !== -1) {
    return successCb({});
  }

  if (!href || !successCb || !errorCb) {
    return errorCb(new Error('The requestNotifications function is missing parameters'));
  }


  request.get(href, {
    headers: {
      'Content-Type': 'application/json',
      'X-App-Key': 'customerexperience'
    }
  }, function notifResponseHandler(error, notifications) {
    if (error || !Array.isArray(notifications)) {
      return errorCb(error || new Error(`expected an array but got ${notifications}`));
    }

    const response = {
      notifications,
      shopperId,
      market,
      timestamp: Date.now()
    };
    successCb(response);
  });
}

requestNotifications.propTypes = {
  errorCb: PropTypes.func.isRequired,
  market: PropTypes.string,
  href: PropTypes.string.isRequired,
  shopperId: PropTypes.string,
  successCb: PropTypes.func.isRequired
};
